export enum GoogleACProviderListField {
    LAST_UPDATED = "lastUpdated",
    PROVIDERS = "providers"
}
